<script setup>
import {useStore} from "vuex";
import {computed} from "vue";
//----------------------------------------------------------------------
const store = useStore()
//----------------------------------------------------------------------
const user = computed( () => {return store.getters['authModule/user']})
//----------------------------------------------------------------------
// показать/скрыть меню
const menu = () => store.commit('menuModule/toggleMenu')
</script>
<template>
  <nav class="main-header navbar navbar-expand navbar-white navbar-light justify-content-between">
      <div v-if="user" class="p-2">
        <router-link :to="{name: 'profile'}" class="black-link">
        {{ user.name }}
        </router-link>
      </div>
      <v-icon
          icon="mdi:menu"
          class="toggle-menu action-icon--black m-2"
          @click="menu"
      ></v-icon>
  </nav>
</template>